/* Split-test registry (theme asset assets/sp-tests.js). Loaded in <head> before sp-ab.js. EMPTY = no tests: everyone sees A.
   One object per running test (ab_test.py start prints the exact entry as REGISTRY_ENTRY):
   { key, pages:["/","/pages/join*"], split:50, start:"ISO", end:"ISO", css:["sp-t-KEY.css"], js:["sp-t-KEY.js"], hide:".selector", rev:"1" }
   Rollback of every test in one push: replace this file with the single line  window.__spTests=[];  */
/* 2026-10-19: join-pop-after-scroll ended 10/15 (winner A) but its entry was never removed; removed now, everyone sees A. */
window.__spTests=[];
